import PropTypes from "prop-types";
import SizeMappingsTable from "./size-mappings-table";
import { useSelector, useDispatch } from "react-redux";
import { DiscoSearchServiceClient } from "clients/disco-search-service-client";
import { setFitNotes, setSizeMappings } from "slices/pdp-slice";

const SizeGuide = ({ designerName, designerNotes }) => {
  const sizeMappings = useSelector(state => state?.pdp?.sizeMappings || []);
  const productId = useSelector(state => state?.staticProduct?.productId);
  const fitNotes = useSelector(state => state?.pdp?.fitNotes || null);
  const dispatch = useDispatch();

  const fetchProductSizeGuide = async () => {
    const sizeGuideRes = await DiscoSearchServiceClient.getInstance().getSizeGuideByProductId(productId);
    const sizeGuide = await sizeGuideRes;
    dispatch(setSizeMappings(sizeGuide?.sizeMappings));
    dispatch(setFitNotes(sizeGuide?.fitNotes || null));
  };

  // Fetch size mappings if they are not already in the store
  if (!sizeMappings || sizeMappings.length === 0) {
    fetchProductSizeGuide();
  }

  return (
    <div className="p-4">
      <h2 className="pb-5">{designerName} Size Guide</h2>
      <div className="pb-3">
        <div className="text-md text-darkGray">Fit Details</div>
        <div dangerouslySetInnerHTML={{ __html: designerNotes }} />
      </div>

      {fitNotes && (
        <div className="pt-3">
          <div className="text-md text-darkGray pb-3">Fit Notes</div>
          <div dangerouslySetInnerHTML={{ __html: fitNotes }} />
        </div>
      )}

      {sizeMappings && sizeMappings.length > 0 && (
        <div className="pt-3">
          <div className="text-md text-darkGray pb-3">Product Sizing</div>
          <SizeMappingsTable sizeMappings={sizeMappings} />
        </div>
      )}
    </div>
  );
};

SizeGuide.propTypes = {
  designerName: PropTypes.string.isRequired,
  designerNotes: PropTypes.string,
};

export default SizeGuide;
